import { Component, ElementRef, forwardRef, Input, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavItem } from './nav-item';


@Component({
    selector: 'ui-nav-link',
    imports: [
        RouterLinkActive,
        RouterLink,
    ],
    styles: [
        `
        .nav-item {
            margin-bottom: -1px;
        }
        .nav-link {
            display: block;
            color: #566e91;
            padding: .5rem 1rem;
        }
        .nav-link:hover,
        .nav-link.active:hover {
            color: #1067a8;
            text-decoration: none;
            border-bottom: 3px #1067a8 solid;
        }
        .nav-link.active {
            color: #1d2531;
            font-weight: 700;
            border-bottom: 3px #1583D6 solid;
        }
        `,
    ],
    providers: [
        {
            provide: NavItem,
            useExisting: forwardRef(() => NavLinkComponent),
        },
    ],
    template: `
        <li class="nav-item">
            <a class="nav-link" [routerLink]="link" routerLinkActive="active" queryParamsHandling="preserve" #content>
                <ng-content></ng-content>
            </a>
        </li>
    `,
})
export class NavLinkComponent extends NavItem {

    @ViewChild('content', { read: ElementRef, static: true }) content: ElementRef;

    @Input() link: string;
}
